// Renders the real SuperCash SVG wordmark from /images/SUPERCASH.svg
export default function Logo({ height = 44, className = "" }) {
  return (
    <img
      src="/images/SUPERCASH.svg"
      alt="SuperCash"
      className={className}
      style={{ height, width: "auto", display: "block", background: "transparent" }}
      draggable={false}
    />
  );
}
